<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
      </nav>
      <div class="copyright pull-right">
        &copy; Developed with
        <i class="fa fa-heart heart"></i> by
        <a href="https://kaweb.co.uk" target="_blank" rel="noopener">Kaweb</a>.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
